import { createContext, useCallback, useContext, useMemo } from 'react'
import { Toaster, toast as sonnerToast } from 'sonner'
import { useI18n } from '../utils/i18n'

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const { tx } = useI18n()
  const removeToast = useCallback((id) => {
    try {
      sonnerToast.dismiss(id)
    } catch {}
  }, [])

  const toast = useCallback(({ kind = 'info', title, message = '', durationMs = 3500 } = {}) => {
    const fallbackTitle = tx({ zh: '提示', en: 'Note' })
    const t = String(title || '').trim() || fallbackTitle
    const desc = String(message || '').trim()
    const opts = { duration: typeof durationMs === 'number' ? durationMs : undefined, description: desc || undefined }
    if (kind === 'success') return sonnerToast.success(t, opts)
    if (kind === 'warning') return sonnerToast.warning(t, opts)
    if (kind === 'error') return sonnerToast.error(t, opts)
    return sonnerToast(t, opts)
  }, [tx])

  const value = useMemo(() => ({ toast, removeToast }), [toast, removeToast])

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toaster position="top-center" richColors closeButton />
    </ToastContext.Provider>
  )
}

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used within <ToastProvider>')
  return ctx
}
